// frontend/src/pages/dashboard/ProjectComponents/ProjectAttachmentsDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography
} from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";

const ProjectAttachmentsDialog = ({
  open,
  onClose,
  selectedProjectAttachments,
  handleDownload
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Project Attachments</DialogTitle>
      <DialogContent>
        {selectedProjectAttachments.length > 0 ? (
          <List dense>
            {selectedProjectAttachments.map((att) => (
              <ListItem key={att.id} secondaryAction={<IconButton onClick={() => handleDownload(att)} color="primary"><DownloadIcon /></IconButton>}>
                <ListItemText primary={att.original_name} secondary={`${(att.size / 1024).toFixed(1)} KB`} />
              </ListItem>
            ))}
          </List>
        ) : (<Typography color="text.secondary">No attachments.</Typography>)}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectAttachmentsDialog;